module.exports = __webpack_public_path__ + "img/draft.899d2267.svg";